import React from 'react';

export default class OneColumn extends React.Component {
    render() {
        var styles = {
            cls1: {
                fill: 'rgba(0,0,0,0.05)'
            },
            cls2: {
                fill: '#fff'
            },
            cls3: {
                fill: 'rgba(0,0,0,0.2)'
            },
            cls4: {
                fill: 'rgba(0,0,0,0.1)'
            },
            cls5: {
                filter: 'url(#Rectangle_243)'
            }
        }
        return <svg id="Group_271" data-name="Group 271" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="svg-holder" viewBox="17414 6855 253 257">
            <defs>
                <filter id="Rectangle_243" x="17425" y="6861" width="230" height="251" filterUnits="userSpaceOnUse">
                    <feOffset dy="-5" />
                    <feGaussianBlur stdDeviation="3" result="blur" />
                    <feFlood floodOpacity="0.039" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <rect id="Rectangle_242" data-name="Rectangle 242" className="outer" width="253" height="253" rx="3" transform="translate(17414 6855)" />
            <g style={styles.cls5} transform="matrix(1, 0, 0, 1, 0, 0)">
                <path id="Rectangle_243-2" data-name="Rectangle 243" style={styles.cls2} d="M3,0H209a3,3,0,0,1,3,3V233a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z" transform="translate(17434 6875)" />
            </g>
            <rect id="Rectangle_244" data-name="Rectangle 244" className="inner" width="192" height="20" rx="3" transform="translate(17444 6885)" />
            <rect id="Rectangle_245" data-name="Rectangle 245" className="inner" width="192" height="60" rx="3" transform="translate(17444 6925)" />
            <rect id="Rectangle_203" data-name="Rectangle 203" className="inner" width="57" height="60" rx="3" transform="translate(17444 7005)" />
            <rect id="Rectangle_204" data-name="Rectangle 204" className="inner" width="57" height="60" rx="3" transform="translate(17511 7005)" />
            <rect id="Rectangle_214" data-name="Rectangle 214" className="inner" width="57" height="60" rx="3" transform="translate(17578 7005)" />
            <rect id="Rectangle_205" data-name="Rectangle 205" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17444 7085)" />
            <rect id="Rectangle_206" data-name="Rectangle 206" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17511 7085)" />
            <rect id="Rectangle_215" data-name="Rectangle 215" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17578 7085)" />
            <rect id="Rectangle_207" data-name="Rectangle 207" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17444 7097)" />
            <rect id="Rectangle_208" data-name="Rectangle 208" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17511 7097)" />
            <rect id="Rectangle_217" data-name="Rectangle 217" style={styles.cls4} width="57" height="4" rx="2" transform="translate(17578 7097)" />
        </svg>


    }
}